import styled from 'styled-components';

import Box from 'ravenjs/lib/Box';

const BreadcrumbsStyled = styled(Box)`
    padding: 0.25rem 0 0.75rem 0;
    ${({ theme }) => theme.media.down('md')`
        padding: 0 0 1.75rem 0;
    `};
    li {
        &:first-child {
            svg {
                position: relative;
                top: 1px;
            }
        }
    }
`;

export default BreadcrumbsStyled;
